export default __webpack_public_path__ + "static/media/receipts-mail.9ee14682.svg";